import React, { useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

function AddContactForm({ onSuccess }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (!localStorage.getItem("access_token")) {
      setError("You must be logged in to add a contact.");
      setLoading(false);
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/contacts/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(form),
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.detail || "Failed to add contact");
      }

      setForm({ name: "", email: "", phone: "" });
      if (onSuccess) onSuccess();
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 600, margin: "auto", padding: 16 }}>
      <h2>Add Contact</h2>
      <input
        name="name"
        type="text"
        placeholder="Full Name"
        value={form.name}
        onChange={handleChange}
        required
        className="input"
      />
      <input
        name="email"
        type="email"
        placeholder="Email Address"
        value={form.email}
        onChange={handleChange}
        required
        className="input"
      />
      <input
        name="phone"
        type="tel"
        placeholder="Phone Number"
        value={form.phone}
        onChange={handleChange}
        required
        className="input"
      />
      {error && <div style={{ color: "red", marginTop: 12 }}>{error}</div>}
      <button
        type="submit"
        className="btn-primary-primary"
        disabled={loading}
        style={{ marginTop: 12 }}
      >
        {loading ? "Saving..." : "Add Contact"}
      </button>
    </form>
  );
}

export default AddContactForm;
